import { render, staticRenderFns } from "./avatarMarker.vue?vue&type=template&id=42932015&scoped=true&"
import script from "./avatarMarker.vue?vue&type=script&lang=js&"
export * from "./avatarMarker.vue?vue&type=script&lang=js&"
import style0 from "./avatarMarker.vue?vue&type=style&index=0&id=42932015&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42932015",
  null
  
)

export default component.exports